import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { TAG_COMPANY_REQUEST } from 'services/TagsConstants';

import { CompanyRequest } from './getCompanyRequests';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
  build.query<CompanyRequest, string>({
    query: (id) => `/company-request/${id}`,
    providesTags: [TAG_COMPANY_REQUEST],
  });
